module.exports = __webpack_public_path__ + "308889d6eeff1c7a3cec13b47b3e2092.pdf";